module.exports = __webpack_public_path__ + "static/media/caret-down.fafa9c0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/caret-down.svg
// module id = 2483
// module chunks = 0